export default class snsManager{
    constructor(){

        /* 必要なDOM */
        this.sns = document.getElementById('c-sns');

    }
    set(){

        TweenMax.set(this.sns,{
            opacity : 1,
            onComplete:()=>{
                TweenMax.staggerFromTo(this.sns.children, 0.9 , {
                    x : 200,
                },{
                    x : 0,
                    ease : Back.easeOut.config(1)
                },0.02);
            }
        });

    }

}